import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { fetch } from 'actions/events'
import Helmet from 'react-helmet'

import CellarLocation from 'components/CellarLocation'
import EventDetails from 'components/EventDetails'
import EventReservation from 'components/EventReservation'
import FBShare from 'components/FBShare'
import TwitterShare from 'components/TwitterShare'
import ShowMore from 'components/ShowMore'
import { croppedImg, getBBURL } from 'utils'
import Carousel from 'nuka-carousel'
// import Lightbox from 'react-image-lightbox';
import { triggerEvent } from 'utils'

export class Event extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      selectedImage: 0,
      isOpen: false,
    }
  }

  componentDidMount() {
    const { event, match } = this.props
    const { eventId } = match.params

    // we no longer want to hide the event page, just hide it from the home
    // const { match, event, history } = this.props;
    // const { eventId, cellarId, lang } = match.params;
    // if (!event.published) {
    //   history.replace(`/${lang}/${cellarId}` +
    //     `?lang=${event.language}`);
    //   return;
    // }

    const anchor = window.location.hash &&
      window.document.getElementById(window.location.hash.slice(1))
    if (anchor) {
      anchor.scrollIntoView(true)
    } else {
      window.document.getElementsByTagName('body')[0].scrollIntoView(true)
    }
    window.fbq && window.fbq('track', 'ViewContent', {
      content_type: 'product',
      content_category: 'event',
      content_name: eventId,
      content_ids: [eventId],
    })
    window.ga && window.ga('send', {
      hitType: 'event',
      eventCategory: 'Reservations',
      eventAction: 'ViewContent',
      eventLabel: 'Event page',
    })
    window.gtag && window.gtag('event', 'view_item', {
      currency: event.location.currency,
      value: event.prices[0] || event.price.value,
      items: [
        {
          item_id: `event-${eventId}`,
          item_name: event.title
        }
      ]
    })
  }

  openLightbox(selectedImage) {
    this.setState({
      selectedImage,
      isOpen: true,
    })
  }

  render() {
    const { events,
      eventsCurrentLanguage,
      match,
      locale } = this.props
    // const { selectedImage, isOpen } = this.state;

    if (!events[match.params.eventId] || !events[match.params.eventId][eventsCurrentLanguage]) {
      return null
    }

    const event = events[match.params.eventId][eventsCurrentLanguage]
    const title = `${event.title} - ${event.cellar.company}`
    const meta = [
      { name: 'description', content: event.description },
      { property: 'og:image', content: croppedImg(event.mainImage, 1000, 500) },
      { property: 'og:image:width', content: 1000 },
      { property: 'og:image:height', content: 500 },
      { property: 'og:url', content: getBBURL() },
      { property: 'og:title', content: title },
      { property: 'og:description', content: event.description },
      { name: 'twitter:card', content: 'summary' },
      { name: 'twitter:site', content: '@wine_around' },
      { name: 'twitter:title', content: title },
      { property: 'twitter:description', content: event.description },
      { property: 'twitter:image', content: croppedImg(event.mainImage, 1000, 500) },
    ]

    if (event.noindex) {
      meta.push({ name: 'robots', content: 'noindex' })
    }

    const images = []
    const imagesItems = [event.mainImage].concat(event.galleryImages).map((imgSrc, i) => {
      const src = croppedImg(imgSrc, 1050, 350)
      images.push(src)
      return (<img
        key={i}
        src={src}
        onLoad={() => triggerEvent(window, 'resize')}
        // onClick={() => {
        //   this.openLightbox(i);
        // }}
      />)
    })

    return (
      <div className="event">
        <Helmet
          title={title}
          meta={meta}
        />
        <div className="event__image-holder" id="event-page__image-holder">
          <Carousel className="event__image" >
            {imagesItems}
          </Carousel>
          {/* {
            isOpen &&
            <Lightbox
              mainSrc={images[selectedImage]}
              nextSrc={images[(selectedImage + 1) % images.length]}
              prevSrc={
                images[(selectedImage + images.length - 1) % images.length]
              }
              onCloseRequest={() => this.setState({ isOpen: false })}
              onMovePrevRequest={() => this.setState({
                selectedImage: (selectedImage + images.length - 1) % images.length,
              })}
              onMoveNextRequest={() => this.setState({
                selectedImage: (selectedImage + 1) % images.length,
              })}
            />
          } */}
        </div>
        <div className="wrap" id="event-page__header">
          <div className="grid">
            <div className="grid__item lap-6-12">
              <div className="event-info">
                <h1
                  className="event-info__title"
                >{ event.title }</h1>
                <ShowMore
                  lines={6}
                  className="event-info__description"
                >
                  <p
                    dangerouslySetInnerHTML={{
                      __html: event.description,
                    }}
                  ></p>
                </ShowMore>
                <FBShare
                  url={window.location.href}
                  title={title}
                />
                <TwitterShare
                  url={window.location.href}
                  title={title}
                />
              </div>
            </div>
            <div className="grid__item lap-6-12">
              <EventDetails
                event={event}
                locale={locale}
              />
            </div>
          </div>
        </div>
        <div>
          <div className="page-body pad--bottom-2">
            <div className="wrap" id="event-page__location-box">
              <CellarLocation location={event.location} />
            </div>
            <EventReservation event={event} />
          </div>
        </div>
      </div>
    )
  }
}

Event.propTypes = {
  event: PropTypes.object.isRequired,
  events: PropTypes.object.isRequired,
  eventsCurrentLanguage: PropTypes.string.isRequired,
  locale: PropTypes.string.isRequired,
  fetchEvent: PropTypes.func.isRequired,
  match: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
}

function mapStateToProps(state) {
  return {
    events: state.events,
    eventsCurrentLanguage: state.languages.eventLanguage,
    locale: state.ui.locale,
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    fetchEvent: fetch,
  }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(Event)
